/**
 * TWWTS — Booking form, miglioramenti mobile (v1.1)
 * Caricato solo sul template "Forms - Book Appointment" (sezione Custom Liquid).
 * - Messaggi inline al posto dei popup alert()
 * - Blocca l'invio mentre le reference sono in upload
 * - Evidenzia e porta in vista il gruppo obbligatorio non compilato
 * - Evita il doppio invio
 * - Oggetto della mail con il nome del cliente
 * - Etichetta accessibile sul campo file nascosto
 * - Testi in italiano se <html lang="it...">
 * - Evento "Booking Request" (Klaviyo, Shopify customer events, GA4, Meta)
 *   dopo l'invio riuscito. Nessun dato personale in sessionStorage.
 */
(function () {
  'use strict';

  var LANG = (document.documentElement.lang || '').toLowerCase();
  var IT = LANG.indexOf('it') === 0;
  var T = IT ? {
    stillUploading: 'Le immagini di riferimento si stanno ancora caricando. Aspetta un momento, poi invia.',
    selectOne: "Seleziona almeno un'opzione",
    sending: 'Invio in corso…',
    refImages: 'Immagini di riferimento'
  } : {
    stillUploading: 'Your reference images are still uploading. Wait a moment, then send.',
    selectOne: 'Select at least one option',
    sending: 'Sending…',
    refImages: 'Reference images'
  };

  var PENDING_KEY = 'twwts_booking_pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000;

  function ssGet() { try { return window.sessionStorage.getItem(PENDING_KEY); } catch (e) { return null; } }
  function ssSet(v) { try { window.sessionStorage.setItem(PENDING_KEY, v); } catch (e) {} }
  function ssDel() { try { window.sessionStorage.removeItem(PENDING_KEY); } catch (e) {} }

  var root = document.querySelector('.twwts-booking');
  if (!root) return;

  /* ── Tracking: pagina di conferma ──
     Il form Shopify, dopo l'invio, ricarica la pagina con ?contact_posted=true
     e la sezione mostra .twwts-booking__success (form.posted_successfully?). */
  try {
    var isSuccess = /[?&]contact_posted=true/.test(window.location.search) ||
      !!root.querySelector('.twwts-booking__success');
    var raw = ssGet();
    if (isSuccess && raw) {
      ssDel(); /* una sola volta, anche se un invio sotto fallisce */
      var payload = null;
      try { payload = JSON.parse(raw); } catch (e) {}
      if (payload && (!payload.ts || (Date.now() - payload.ts) < PENDING_MAX_AGE)) {
        try {
          if (window.klaviyo && typeof window.klaviyo.push === 'function') {
            window.klaviyo.push(['track', 'Booking Request', payload]);
          } else if (window._learnq && typeof window._learnq.push === 'function') {
            window._learnq.push(['track', 'Booking Request', payload]);
          }
        } catch (e) {}
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('twwts_booking_request', payload);
          }
        } catch (e) {}
        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', { form: 'booking', studio: payload.studio });
          }
        } catch (e) {}
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'Lead', { content_name: 'Booking request' });
          }
        } catch (e) {}
      }
    } else if (!isSuccess && raw && root.querySelector('form.twwts-form .twwts-form__notice--error')) {
      /* Invio respinto da Shopify (errori): niente evento */
      ssDel();
    }
  } catch (e) {}

  var form = root.querySelector('form.twwts-form');
  if (!form) return;
  var submitBtn = form.querySelector('.twwts-form__submit');
  var submitLabel = submitBtn ? submitBtn.textContent : '';

  /* Campo file: il bottone visibile lo apre, ma serve un nome per gli screen reader */
  root.querySelectorAll('.twwts-form__file-input').forEach(function (input) {
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', T.refImages);
  });

  /* ── Notice inline ── */
  var notice = document.createElement('div');
  notice.className = 'twwts-form__notice twwts-form__notice--error twwts-plus__notice';
  notice.setAttribute('role', 'alert');
  notice.hidden = true;
  if (submitBtn) submitBtn.parentNode.insertBefore(notice, submitBtn);

  var hideTimer;
  function showNotice(msg, anchor) {
    notice.textContent = msg;
    notice.hidden = false;
    var target = anchor || notice;
    if (anchor && anchor !== notice) {
      anchor.parentNode.insertBefore(notice, anchor.nextSibling);
    }
    try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { notice.hidden = true; }, 8000);
  }

  /* Le alert() della sezione (file troppo grandi, upload falliti, limiti)
     diventano messaggi inline vicino all'upload. */
  var uploadField = root.querySelector('[data-upload-trigger]');
  var uploadAnchor = uploadField ? uploadField.closest('fieldset') : null;
  window.alert = function (msg) {
    var text = String(msg || '');
    if (/at least one option|almeno un'opzione/i.test(text)) return; /* gestito sotto, con il gruppo evidenziato */
    showNotice(text, uploadAnchor || notice);
  };

  /* ── Submit: controlli prima della logica originale ── */
  form.addEventListener('submit', function (e) {
    /* 1. Upload ancora in corso */
    if (root.querySelector('.twwts-form__upload-item.is-pending')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showNotice(T.stillUploading, uploadAnchor || notice);
      return;
    }

    /* 2. Gruppi "almeno una scelta" */
    var firstFailed = null;
    root.querySelectorAll('[data-require-at-least-one]').forEach(function (g) {
      var ok = g.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      g.classList.toggle('is-invalid', !ok);
      if (!ok && !firstFailed) firstFailed = g;
    });
    if (firstFailed) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var legend = firstFailed.querySelector('legend');
      showNotice(T.selectOne + (legend ? ': ' + legend.textContent.replace('*', '').trim() : '') + '.', firstFailed);
      return;
    }

    /* 3. Oggetto mail con il nome */
    var subject = form.querySelector('[data-subject-input]');
    var nameInput = form.querySelector('input[name="contact[name]"]');
    if (subject && nameInput && nameInput.value.trim()) {
      var base = subject.getAttribute('data-base') || subject.value;
      subject.setAttribute('data-base', base);
      subject.value = base + ' · ' + nameInput.value.trim();
    }

    /* 4. Niente doppio invio (dopo che gli altri listener hanno deciso) */
    setTimeout(function () {
      if (e.defaultPrevented || !submitBtn) return;
      submitBtn.disabled = true;
      submitBtn.classList.add('is-sending');
      submitBtn.textContent = T.sending;
    }, 0);

    /* 5. Tracking: salva il contesto (niente dati personali) e identifica il profilo */
    setTimeout(function () {
      if (e.defaultPrevented) return;
      try {
        var studioEl = form.querySelector('input[type="radio"][name="contact[studio]"]:checked');
        var methods = [];
        form.querySelectorAll('input[type="checkbox"][data-cb-group="contact_method"]:checked').forEach(function (cb) {
          methods.push(cb.value);
        });
        var hasRefs = root.querySelectorAll('.twwts-form__upload-item:not(.is-pending)').length > 0;
        ssSet(JSON.stringify({
          studio: studioEl ? studioEl.value : '',
          contact_methods: methods,
          has_references: hasRefs,
          language: LANG || 'en',
          ts: Date.now()
        }));
      } catch (err) {}
      try {
        var emailEl = form.querySelector('input[name="contact[email]"]');
        var email = emailEl ? emailEl.value.trim() : '';
        if (email && window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email: email });
        }
      } catch (err) {}
    }, 0);
  }, true);

  /* Togli l'evidenziazione appena il gruppo viene compilato */
  root.querySelectorAll('[data-require-at-least-one]').forEach(function (g) {
    g.addEventListener('change', function () {
      if (g.querySelectorAll('input[type="checkbox"]:checked').length) g.classList.remove('is-invalid');
    });
  });

  /* Campo non valido: porta in vista il campo, non solo il tooltip nativo */
  form.addEventListener('invalid', function (e) {
    var el = e.target;
    var row = el.closest('.twwts-form__row, .twwts-form__fieldset, label');
    if (row) row.classList.add('is-invalid');
    el.addEventListener('input', function () { if (row) row.classList.remove('is-invalid'); }, { once: true });
    el.addEventListener('change', function () { if (row) row.classList.remove('is-invalid'); }, { once: true });
  }, true);

  /* Se si torna indietro dalla pagina di conferma, riattiva il bottone */
  window.addEventListener('pageshow', function () {
    if (submitBtn && submitBtn.classList.contains('is-sending')) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-sending');
      submitBtn.textContent = submitLabel;
    }
  });
})();
